module.exports = require('event-source-polyfill').EventSourcePolyfill
